export const structuredTheme = (data) => {
  return {
    ...data.theme,
    processor: data.processor,
    copyright_company_name: data.copyright_company_name,
  };
};
